export const LayoutOptions = [
  {"label": "Vertical", "value": "vertical"},
  {"label": "Horizontal", "value": "horizontal"}
]
